(function(){
  // reveal on scroll
  var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});},{threshold:.12});
  function bindReveal(){document.querySelectorAll('.reveal:not(.vis)').forEach(function(el){obs.observe(el);});}
  document.addEventListener('DOMContentLoaded',bindReveal);
  document.addEventListener('shopify:section:load',bindReveal);

  // sticky header + back to top
  var hdr=document.querySelector('.hdr');var top=document.querySelector('.totop');
  window.addEventListener('scroll',function(){
    var y=window.scrollY;
    if(hdr)hdr.classList.toggle('scrolled',y>20);
    if(top)top.classList.toggle('show',y>500);
  });
  if(top)top.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});

  // open/close drawers
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-menu-open]')){document.querySelector('.drawer').classList.add('open');document.querySelector('.overlay').classList.add('open');}
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openCart();}
    if(e.target.closest('[data-close]')||e.target.classList.contains('overlay')){closeAll();}
  });
  function closeAll(){document.querySelectorAll('.drawer,.cart-drawer').forEach(function(d){d.classList.remove('open');});document.querySelector('.overlay').classList.remove('open');}
  function openCart(){var c=document.querySelector('.cart-drawer');if(c){c.classList.add('open');document.querySelector('.overlay').classList.add('open');refreshCart();}}

  // accordion
  document.addEventListener('click',function(e){
    var h=e.target.closest('.acc__h');if(!h)return;
    var it=h.parentElement;var b=it.querySelector('.acc__b');
    var open=it.classList.toggle('open');b.style.maxHeight=open?b.scrollHeight+'px':null;
  });

  // gallery thumbs
  document.addEventListener('click',function(e){
    var t=e.target.closest('.gal__th button');if(!t)return;
    var main=document.querySelector('.gal__main img');
    if(main){main.src=t.getAttribute('data-full');main.srcset='';}
    document.querySelectorAll('.gal__th button').forEach(function(b){b.classList.remove('on');});t.classList.add('on');
  });

  // quantity
  document.addEventListener('click',function(e){
    var b=e.target.closest('.qty button');if(!b)return;
    var i=b.parentElement.querySelector('input');var v=parseInt(i.value||'1',10);
    b.dataset.dir==='up'?v++:v=Math.max(1,v-1);i.value=v;
  });

  // variant selector -> price + id
  var pform=document.querySelector('[data-pform]');
  if(pform){
    var dj=document.getElementById('variant-json');
    if(dj){var vs=[];try{vs=JSON.parse(dj.textContent);}catch(e){}
      function money(c){return 'R$ '+(c/100).toFixed(2).replace('.',',');}
      function upd(){var sels=pform.querySelectorAll('[data-opt]');var ch=[];sels.forEach(function(s){ch.push(s.value);});
        var m=vs.find(function(v){return v.options.join(' / ')===ch.join(' / ');})||vs[0];if(!m)return;
        pform.querySelector('[name="id"]').value=m.id;
        var pr=document.querySelector('[data-price]');if(pr)pr.textContent=money(m.price);
        var btn=pform.querySelector('[data-add]');if(btn){btn.disabled=!m.available;btn.textContent=m.available?'Adicionar à sacola':'Esgotado';}
      }
      pform.querySelectorAll('[data-opt]').forEach(function(s){s.addEventListener('change',upd);});upd();
    }
  }

  // AJAX add to cart (works for product form and quick add)
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-cart-form]');if(!f)return;
    e.preventDefault();
    var fd=new FormData(f);
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();}).then(function(){openCart();}).catch(function(){f.submit();});
  });

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var body=document.querySelector('.cart-drawer__body');var foot=document.querySelector('[data-cart-total]');
      var cnt=document.querySelector('.cart-count');
      if(cnt)cnt.textContent=cart.item_count;
      if(!body)return;
      if(cart.item_count===0){body.innerHTML='<p class="muted" style="text-align:center;padding:40px 0">Sua sacola está vazia.</p>';if(foot)foot.textContent='';return;}
      var html='';cart.items.forEach(function(it){
        html+='<div class="ci"><img src="'+(it.image?it.image:'')+'" alt=""><div><div class="ci__t">'+it.product_title+'</div><div class="muted" style="font-size:.8rem">'+(it.variant_title||'')+'</div><div class="ci__p">'+money(it.final_line_price)+'</div><div class="muted" style="font-size:.8rem">Qtd: '+it.quantity+'</div></div></div>';
      });
      body.innerHTML=html;
      if(foot)foot.textContent=money(cart.total_price);
    });
    function money(c){return 'R$ '+(c/100).toFixed(2).replace('.',',');}
  }

  // slideshow (generic)
  document.querySelectorAll('[data-slideshow]').forEach(function(root){
    var track=root.querySelector('[data-track]');if(!track)return;
    var slides=root.querySelectorAll('.stc-slide');var dots=root.querySelectorAll('[data-dots] .stc-dot');
    var i=0,total=slides.length;var ap=root.getAttribute('data-autoplay')==='true';var iv=parseInt(root.getAttribute('data-interval'))||6000;var t=null;
    function go(n){i=(n+total)%total;track.style.transform='translateX('+(-i*100)+'%)';slides.forEach(function(s,x){s.classList.toggle('is-active',x===i);});dots.forEach(function(d,x){d.classList.toggle('active',x===i);});}
    function nx(){go(i+1);}function pv(){go(i-1);}function st(){if(ap&&total>1){sp();t=setInterval(nx,iv);}}function sp(){if(t){clearInterval(t);t=null;}}
    var pb=root.querySelector('[data-prev]');if(pb)pb.addEventListener('click',function(){pv();st();});
    var nb=root.querySelector('[data-next]');if(nb)nb.addEventListener('click',function(){nx();st();});
    dots.forEach(function(d){d.addEventListener('click',function(){go(parseInt(d.getAttribute('data-goto')));st();});});
    root.addEventListener('mouseenter',sp);root.addEventListener('mouseleave',st);
    go(0);st();
  });

  // countdown
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end=new Date(el.getAttribute('data-countdown')).getTime();if(isNaN(end))return;
    function tick(){var d=end-Date.now();if(d<0)d=0;
      var days=Math.floor(d/864e5),h=Math.floor(d%864e5/36e5),m=Math.floor(d%36e5/6e4),s=Math.floor(d%6e4/1e3);
      var q=el.querySelectorAll('.n');if(q.length===4){q[0].textContent=days;q[1].textContent=('0'+h).slice(-2);q[2].textContent=('0'+m).slice(-2);q[3].textContent=('0'+s).slice(-2);}
    }tick();setInterval(tick,1000);
  });
})();
